import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 解决跳转当前页面控制台报错的问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  { // 首页
    path: '/countDown',
    name: 'CountDown',
    component: () => import('../views/countDown/countDown.vue'),
    meta: { backTopShow: true, loginHeader: true }
  },
  { // 首页
    path: '/index',
    name: 'index',
    component: () => import('../views/index/index.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 搜索
    path: '/search',
    name: 'search',
    component: () => import('../views/search/search.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 搜索报考
    path: '/searchExam',
    name: 'searchExam',
    component: () => import('../views/searchExam/searchExam.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 登录
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    meta: { loginHeader: true, fullScreen: true, title: '欢迎登录', backTopShow: true }
  },
  { // 注册
    path: '/register',
    name: 'register',
    component: () => import('../views/register/register.vue'),
    meta: { loginHeader: true, fullScreen: true, title: '免费注册', backTopShow: true }
  },
  { // 快捷登录
    path: '/registerFast',
    name: 'registerFast',
    component: () => import('../views/registerFast/registerFast.vue'),
    meta: { loginHeader: true, fullScreen: true, title: '快捷登录', backTopShow: true }
  },
  { // 忘记密码
    path: '/forget',
    name: 'forget',
    component: () => import('../views/forget/forget.vue'),
    meta: { loginHeader: true, fullScreen: true, title: '找回密码', backTopShow: true }
  },
  { // 报考列表
    path: '/examine',
    name: 'examine',
    component: () => import('../views/examine/examine.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 成绩查询
    path: '/resultSearch',
    name: 'resultSearch',
    component: () => import('../views/examine/resultSearch.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 报考详情
    path: '/examineDetails',
    name: 'examineDetails',
    component: () => import('../views/examineDetails/examineDetails.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 报考确认个人信息
    path: '/confirmInfor',
    name: 'confirmInfor',
    component: () => import('../views/examineDetails/confirmInfor.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 公示详情
    path: '/publicityDetails',
    name: 'publicityDetails',
    component: () => import('../views/publicityDetails/publicityDetails.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 招聘列表
    path: '/workList',
    name: 'workList',
    component: () => import('../views/workList/workList.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 空中招聘
    path: '/Air',
    name: 'Air',
    component: () => import('../views/Air/Air.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 空中招聘
    path: '/Air/detail',
    name: 'Airdetail',
    component: () => import('../views/Air/Airdtail.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 招聘详情页
    path: '/workDetails',
    name: 'workDetails',
    component: () => import('../views/workDetails/workDetails.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 企业详情页
    path: '/companyDetails',
    name: 'companyDetails',
    component: () => import('../views/companyDetails/companyDetails.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 劳务派遣列表
    path: '/dispatchList',
    name: 'dispatchList',
    component: () => import('../views/dispatchList/dispatchList.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 劳务派遣详情页
    path: '/dispatchDetails',
    name: 'dispatchDetails',
    component: () => import('../views/dispatchDetails/dispatchDetails.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 平台公告
    path: '/news',
    name: 'news',
    component: () => import('../views/news/news.vue'),
    meta: { backTopShow: true }
  },
  { // 平台公告
    path: '/newsDetail',
    name: 'newsDetail',
    component: () => import('../views/newsDetail/newsDetail.vue'),
    meta: { backTopShow: true }
  },
  { // 帮助中心
    path: '/help',
    name: 'help',
    component: () => import('../views/help/help.vue'),
    meta: { backTopShow: true }
  },
  { // 关于我们
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../views/aboutUs/aboutUs.vue'),
    meta: { fullScreen: true, backTopShow: true }
  },
  { // 个人账户 - 账户中心
    path: '/account/personalAccount/pUserCenter',
    name: 'pUserCenter',
    component: () => import('../views/account/personalAccount/pUserCenter/pUserCenter.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 个人账户 - 我的简历
    path: '/account/personalAccount/pResume',
    name: 'pResume',
    component: () => import('../views/account/personalAccount/pResume/pResume.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 个人账户 - 我的简历
    path: '/account/personalAccount/blockCompany',
    name: 'BlockCompany',
    component: () => import('../views/account/personalAccount/pResume/BlockCompany.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 个人账户 - 劳务派遣
    path: '/account/pDispatch/pDispatch',
    name: 'pDispatch',
    component: () => import('../views/account/personalAccount/pDispatch/pDispatch.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 个人账户 - 工资列表
    path: '/account/pSalaryManage/pSalaryManage',
    name: 'pSalaryManage',
    component: () => import('../views/account/personalAccount/pSalaryManage/pSalaryManage.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 个人账户 - 投递记录
    path: '/account/personalAccount/pRecord',
    name: 'pRecord',
    component: () => import('../views/account/personalAccount/pRecord/pRecord.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 个人账户 - 我的报考
    path: '/account/personalAccount/pExamine',
    name: 'pExamine',
    component: () => import('../views/account/personalAccount/pExamine/pExamine.vue'),
    meta: { accountMenu: true }
  },
  { // 个人账户 - 打印准考证
    path: '/account/personalAccount/pExameDocket',
    name: 'pExameDocket',
    component: () => import('../views/account/personalAccount/pExamine/pExameDocket.vue'),
    meta: { fullScreen: true, noHeaderFooter: true, backTopShow: true }
  },
  { // 个人账户 - 打印准考证
    path: '/account/personalAccount/pExameInterviewDocket',
    name: 'pExameInterviewDocket',
    component: () => import('../views/account/personalAccount/pExamine/pExameInterviewDocket.vue'),
    meta: { fullScreen: true, noHeaderFooter: true, backTopShow: true }
  },
  { // 个人账户 - 安全中心
    path: '/account/personalAccount/pSafe',
    name: 'pSafe',
    component: () => import('../views/account/personalAccount/pSafe/pSafe.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 企业账户 - 账户中心
    path: '/account/companyAccount/cUserCenter',
    name: 'cUserCenter',
    component: () => import('../views/account/companyAccount/cUserCenter/cUserCenter.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 企业账户 - 企业信息
    path: '/account/companyAccount/cInfor',
    name: 'cInfor',
    component: () => import('../views/account/companyAccount/cInfor/cInfor.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 企业账户 - 搜索简历
    path: '/account/companyAccount/cFindResume',
    name: 'cFindResume',
    component: () => import('../views/account/companyAccount/cFindResume/cFindResume.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 企业账户 - 招聘管理
    path: '/account/companyAccount/cRecruitment',
    name: 'cRecruitment',
    component: () => import('../views/account/companyAccount/cRecruitment/cRecruitment.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 企业账户 - 招聘管理 - 投递记录
    path: '/account/companyAccount/cRecruitment/cRecordByCrecruitment',
    name: 'cRecordByCrecruitment',
    component: () => import('../views/account/companyAccount/cRecruitment/cRecordByCrecruitment.vue'),
    meta: { backTopShow: true }
  },
  { // 企业账户 - 查看简历
    path: '/account/companyAccount/cResume',
    name: 'cResume',
    component: () => import('../views/account/companyAccount/cResume/cResume.vue'),
    meta: { fullScreen: true, noHeaderFooter: true, backTopShow: true }
  },
  { // 企业账户 - 投递记录
    path: '/account/companyAccount/cRecord',
    name: 'cRecord',
    component: () => import('../views/account/companyAccount/cRecord/cRecord.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 企业账户 - 安全中心
    path: '/account/companyAccount/cSafe',
    name: 'cSafe',
    component: () => import('../views/account/companyAccount/cSafe/cSafe.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 账户中心
    path: '/account/administrationAccount/cUserCenter',
    name: 'aUserCenter',
    component: () => import('../views/account/administrationAccount/cUserCenter/cUserCenter.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 企业信息
    path: '/account/administrationAccount/cInfor',
    name: 'aInfor',
    component: () => import('../views/account/administrationAccount/cInfor/cInfor.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 搜索简历
    path: '/account/administrationAccount/cFindResume',
    name: 'aFindResume',
    component: () => import('../views/account/administrationAccount/cFindResume/cFindResume.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 招聘管理
    path: '/account/administrationAccount/cRecruitment',
    name: 'aRecruitment',
    component: () => import('../views/account/administrationAccount/cRecruitment/cRecruitment.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 企业账户 - 招聘管理 - 投递记录
    path: '/account/administrationAccount/cRecruitment/cRecordByCrecruitment',
    name: 'aRecordByCrecruitment',
    component: () => import('../views/account/administrationAccount/cRecruitment/cRecordByCrecruitment.vue'),
    meta: { backTopShow: true }
  },
  { // 机关事业单位 - 劳务派遣
    path: '/account/administrationAccount/cLabour',
    name: 'aLabour',
    component: () => import('../views/account/administrationAccount/cLabour/aLabour.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 岗位管理
    path: '/account/administrationAccount/cLabour/aPostManage',
    name: 'aPostManage',
    component: () => import('../views/account/administrationAccount/cLabour/aPostManage/aPostManage.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 人员管理
    path: '/account/administrationAccount/cLabour/aPersonManage',
    name: 'aPersonManage',
    component: () => import('../views/account/administrationAccount/cLabour/aPersonManage/aPersonManage.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 工资管理
    path: '/account/administrationAccount/cLabour/aSalaryManage',
    name: 'aSalaryManage',
    component: () => import('../views/account/administrationAccount/cLabour/aSalaryManage/aSalaryManage.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 投递记录
    path: '/account/administrationAccount/cRecord',
    name: 'aRecord',
    component: () => import('../views/account/administrationAccount/cRecord/cRecord.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 机关事业单位 - 查看简历
    path: '/account/administrationAccount/cResume',
    name: 'aResume',
    component: () => import('../views/account/administrationAccount/cResume/cResume.vue'),
    meta: { fullScreen: true, noHeaderFooter: true, backTopShow: true }
  },
  { // 机关事业单位 - 安全中心
    path: '/account/administrationAccount/cSafe',
    name: 'aSafe',
    component: () => import('../views/account/administrationAccount/cSafe/cSafe.vue'),
    meta: { accountMenu: true, backTopShow: true }
  },
  { // 我要报考 - 查看报考条件
    path: '/examineDetails/condition',
    name: 'checkCondition',
    component: () => import('../views/examineDetails/condition.vue'),
    meta: { fullScreen: false, noHeaderFooter: false, backTopShow: true }
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ y: 0 })
});

export default router;
